import React, { useState } from "react";

import logo from "./../Images/vistaplots-logo.png";

import { toast } from "react-toastify";
import CustomToast from "../Components/CustomToast/CustomToast";
import { forgotPassword } from "../Services/api";
import { useNavigate } from "react-router-dom";
function ForgotPassword() {
  const navigate = useNavigate();

  const [email, setEmail] = useState();

  const doReset = async () => {
    try {
      const request = { email };
      const resetPassResp = await forgotPassword(request);
      toast(<CustomToast type="success" message={resetPassResp.msg} />, {
        autoClose: 3000,
      });
      navigate("/forgot-password-email");
    } catch (error) {
      toast(<CustomToast type="error" message={error} />, {
        autoClose: 3000,
      });
    }
  };

  return (
    <>
      <div className="doc-area">
        <div className="container h-100">
          <div className="doc-box">
            <div className="doc-inner">
              <div className="max-500">
                <div class="frgt-logo text-center mb-3">
                  <img src={logo} width={65} alt="" />
                </div>

                <div class="frgt-title text-center">
                  <h3>Forgot your password? 🙈</h3>
                  <p>
                    No problem! Enter your email address and we'll send you a
                    link to reset your password.
                  </p>
                </div>
                <div class="signup-form">
                  <form action="">
                    <div class="row">
                      <div className="mb-4 col-lg-12">
                        <label className="mb-2">Email Address*</label>
                        <input
                          type="email"
                          onChange={(event) => {
                            if (event.target.value) {
                              setEmail(event.target.value);
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div class="text-center reset-button">
                      <button
                        className="text-center mb-2"
                        onClick={(event) => {
                          event.preventDefault();
                          doReset();
                        }}
                      >
                        Reset Password
                      </button>
                      <a href="">Cancel</a>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ForgotPassword;
